import { ProductListEntityTagsFilterState } from "@/admin/community/product-list/ProductListTagsDropdown"
import EntityTagList from "@/admin/settings/tabs/EntityTagList"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import DiscoTableSearchInput from "@disco-ui/table/header/search/DiscoTableSearchInput"
import { TestIDProps } from "@utils/typeUtils"
import { useState } from "react"

interface Props extends TestIDProps {
  filterState: ProductListEntityTagsFilterState
  setFilterState: (state: ProductListEntityTagsFilterState) => void
}

function EntityTagListPopoverContent({
  testid = "EntityTagListPopoverContent",
  filterState,
  setFilterState,
}: Props) {
  const classes = useStyles()
  const [search, setSearch] = useState<string>("")

  return (
    <div>
      <DiscoTableSearchInput
        testid={testid}
        placeholder={"Type to search tags"}
        onChange={setSearch}
        onClick={(e) => e.stopPropagation()}
        classes={{ root: classes.input }}
      />

      <EntityTagList
        testid={`${testid}.list`}
        filterState={filterState}
        setFilterState={setFilterState}
        search={search}
      />
    </div>
  )
}

const useStyles = makeUseStyles((theme) => ({
  input: {
    border: theme.palette.constants.borderSmall,
    marginBottom: theme.spacing(1.5),
  },
}))

export default EntityTagListPopoverContent
